export default {
  buttonText: "Log In",
  forgotPasswordText: "Forgot your password?",
  forgotUsernameText: "Forgot your username?",
  header: "Log in",
  label1: "Username or Email",
  label2: "Password"
};
